/* Salvona — fade blocks in once when they enter the screen, then leave them fully visible */
(function(){
  var root=document.documentElement;
  window.svRevealReady=true;
  if(!root.classList.contains('sv-reveal-on')) return;
  function show(el){
    if(el.classList.contains('is-in')) return;
    io.unobserve(el);
    el.classList.add('is-in');
    setTimeout(function(){el.classList.remove('sv-reveal','is-in');el.style.transitionDelay='';},1400);
  }
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting) show(e.target); });
  },{rootMargin:'0px 0px -6% 0px',threshold:0.01});
  function scan(scope){
    var els=(scope||document).querySelectorAll('.sv-reveal:not(.is-in)');
    var groups=new Map();
    els.forEach(function(el){
      var p=el.parentElement,i=groups.get(p)||0; groups.set(p,i+1);
      if(i) el.style.transitionDelay=Math.min(i,5)*80+'ms';
      io.observe(el);
    });
  }
  /* backup: a fast scroll can jump past a block; anything already above the bottom of the screen gets shown */
  var ticking=false;
  function sweep(){
    ticking=false;
    var h=window.innerHeight;
    document.querySelectorAll('.sv-reveal:not(.is-in)').forEach(function(el){
      var r=el.getBoundingClientRect();
      if(r.width && r.top<h) show(el);
    });
  }
  document.addEventListener('scroll',function(){ if(!ticking){ticking=true;requestAnimationFrame(sweep);} },{capture:true,passive:true});
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){scan();}); else scan();
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
  new MutationObserver(function(muts){muts.forEach(function(m){m.addedNodes.forEach(function(n){if(n.nodeType===1){if(n.classList.contains('sv-reveal'))scan(n.parentElement);else if(n.querySelector&&n.querySelector('.sv-reveal'))scan(n);}});});}).observe(document.body,{childList:true,subtree:true});
})();
